import { render, staticRenderFns } from "./ConfirmDialog.vue?vue&type=template&id=6626227c&scoped=true"
import script from "./ConfirmDialog.vue?vue&type=script&lang=ts"
export * from "./ConfirmDialog.vue?vue&type=script&lang=ts"
import style0 from "./ConfirmDialog.vue?vue&type=style&index=0&id=6626227c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6626227c",
  null
  
)

export default component.exports